import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8f75bc4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "title", "aria-label", "aria-hidden", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    id: _ctx.$attrs.id,
    class: _normalizeClass(["cm-svg-icon", [_ctx.$attrs.class, { 'cm-svg-icon--monochrome': _ctx.monochrome }]]),
    style: _normalizeStyle(_ctx.mergedStyle),
    title: _ctx.title,
    "aria-label": _ctx.ariaLabel,
    "aria-hidden": _ctx.ariaHidden,
    role: "img",
    innerHTML: _ctx.svgHtml
  }, null, 14, _hoisted_1))
}